module.exports = __webpack_public_path__ + "static/media/smile-dizzy.f6aa3537.svg";